import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=2f7721e1&"
import script from "./Inspections.vue?vue&type=script&lang=ts&"
export * from "./Inspections.vue?vue&type=script&lang=ts&"
import style0 from "./Inspections.vue?vue&type=style&index=0&id=2f7721e1&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports